<template>
    <div class="select-holder relative w-full float-left bg-white rounded-lg mb-4" :class="[hover && !focused && !hasErrors ? 'text-primary-default' : '', hover && focused && !hasErrors || focused && !hasErrors ? 'text-primary-darker' : '', !hover && !hasErrors ? 'text-gray-700' : '', hasErrors ? 'text-secondary-default' : '']" @mouseover="hover = true" @mouseleave="hover = false">
        <label v-if="label" :for="(idPrefix ?idPrefix +'_':'')+'select_' +name" :class="[labelClass ? labelClass : '',hover && !focused && !hasErrors ? 'text-primary-default' : '', hover && focused && !hasErrors || focused && !hasErrors ? 'text-primary-darker' : '', !hover && !hasErrors ? 'text-gray-500' : '', hasErrors ? 'text-secondary-default' : '']" class="absolute left-3 -top-4 px-1 pointer-events-none border-2 border-t-4 bg-white border-white rounded transition-all ease-in-out duration-500">{{ $t(label) }}<span v-html="labelNotice ? ' ' + labelNotice : ''"></span></label>

        <select
            :id="(idPrefix ?idPrefix +'_':'')+'select_' +name"
            :name="name"
            :ref="name"
            class="border-2 rounded transition-all ease-in-out duration-500 w-full h-12 px-4 py-2 outline-none"
            :class="[{'opacity-25 cursor-not-allowed':disabled} , selectClass ? selectClass : '' , hover && !focused && !hasErrors ? 'border-primary-default' : '', hover && focused && !hasErrors || focused && !hasErrors ? 'border-primary-darker' : '', !hover && !hasErrors ? 'border-gray-300' : '', hasErrors ? 'border-secondary-light text-secondary-default' : '']"
            :autocomplete="autocomplete"
            :disabled="disabled"
            @change="$emit('change', $event.target.value)"
            @input="$emit('input', $event.target.value)"
            @blur="$emit('blur');onBlur();"
            @keyup.enter="$emit('keyup.enter', $event.target.value)"
            @keyup="$emit('keyup', $event)"
            @focus="$emit('focus', $event),onFocus();"
            @click="$emit('click', $event)"
        >
            <!--<option disabled selected value v-if="!selected" />-->
            <option
                v-for="(option, key) in options"
                :key="key"
                :value="option.value"
                v-bind="{selected: option.value == selected}"
            >
                {{ option.label }}
            </option>
        </select>
        <i class="zmdi absolute text-2xl right-3 top-2.5 zmdi-chevron-down transform transition-all ease-in-out duration-500" :class="[hover ? 'rotate-90' : 'rotate-0']"></i>
        <ValidationMessages v-if="validations" :validations="validations" :hide-errors="hideErrors" :has-errors="hasErrors" :error-position="errorPosition"/>
    </div>
</template>

<script>
    import ValidationMessages from './ValidationMessages.vue'

    export default {

        data() {
            return {
                focused: false,
                hover: false
            }
        },
        components: {
            ValidationMessages
        },
        props: {
            id: {
                type: String,
                required: false,
                default: ''
            },
            idPrefix: {
                type: String,
                required: false,
                default: ''
            },
            name: {
                type: String,
                required: false,
                default: ''
            },
            options: {
                type: Array,
                required: true,
                default: () => []
            },
            selected: {
                type: [String, Number],
                required: false,
                default: ''
            },
            label: {
                type: String,
                required: false,
                default: ''
            },
            labelClass: {
                type: String,
                required: false,
                default: ''
            },
            labelNotice: {
                type: String,
                required: false,
                default: ''
            },
            autocomplete: {
                type: String,
                required: false,
                default: ''
            },
            validations: {
                type: Array,
                default: () => []
            },
            selectClass: {
                type: String,
                required: false,
                default: ''
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            hideErrors: {
                type: Boolean,
                required: false,
                default: true
            },
            errorPosition: {
                type: String,
                required: false
            },

        },
        watch: {
            selected(selected) {
                this.dropdownSelected = selected
            }
        },
        computed: {
            hasErrors() {
                var hasErrors = false;
                this.validations.forEach(validation => {

                    if (validation.condition) {
                        hasErrors = true;
                        return;
                    }
                })

                return hasErrors;
            }
        },
        methods: {
            onFocus() {
                this.focused = true;
            },
            onBlur() {
                this.focused = false;
            },
            setFocus(fieldName) {
                if (this.name === fieldName) {
                    this.$refs[this.name].focus()
                }
            }
        },
    }
</script>
<style scoped>
    select {
        -webkit-appearance: none;
        /*webkit browsers */
        -moz-appearance: none;
        /*Firefox */
        appearance: none;
    }
</style>
